import React from "react";
import styles from "./auth_style.module.css";
import { useHistory } from "react-router-dom";
import christmasLogoSingle from "../../assets/svgs/christmasLogoSingle.svg";
import logoSingle from "../../assets/svgs/logoSingle.svg";
import christmasLight from "../../assets/images/bannerLight.png";
import { checkIfChristmasPeriod } from "../../utils/checkIfChristmasPeriod";

export default function AuthPageWrapper({ children }) {
	const { push } = useHistory();
	const isChristmas = checkIfChristmasPeriod();

	return (
		<div className={`${styles.auth_container}`}>
			<div className={`${styles.auth_card} bg-white`}>
				{isChristmas && (
					<>
						<img
							src={christmasLight}
							alt="christmas Light"
							className={`${styles.light}`}
						/>
					</>
				)}
				<div
					className={`mt-5 pt-2 pr-2 d-flex align-items-center justify-content-center`}
				>
					<img
						src={isChristmas ? christmasLogoSingle : logoSingle}
						alt="fedpod's logo"
						onClick={() => push("/")}
						style={{
							width: isChristmas ? "110px" : "80px"
						}}
					/>
				</div>
				{children}
			</div>
		</div>
	);
}
